module.exports = __webpack_public_path__ + "public/1.0.1_200686/img/72.ab600ed7.png";